import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from '../firebase.js';
import { getFirestore, doc, getDoc, setDoc,addDoc, Timestamp , updateDoc} from "firebase/firestore";
import { getDocs, collection, query, where } from "firebase/firestore";
import { Button, Form, Row, Col, Container, Card, InputGroup, Modal, Spinner, ProgressBar } from 'react-bootstrap';
import swal from 'sweetalert'; 
import { getStorage, ref, uploadBytes, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { Navigate, useNavigate } from "react-router-dom";

const db = getFirestore(app);

const counties = [
  "Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo Marakwet", "Embu", "Garissa",
  "Homa Bay", "Isiolo", "Kajiado", "Kakamega", "Kericho", "Kiambu", "Kilifi",
  "Kirinyaga", "Kisii", "Kisumu", "Kitui", "Kwale", "Laikipia", "Lamu", "Machakos",
  "Makueni", "Mandera", "Marsabit", "Meru", "Migori", "Mombasa", "Murang’a",
  "Nairobi", "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua", "Nyeri", "Samburu",
  "Siaya", "Taita Taveta", "Tana River", "Tharaka-Nithi", "Trans Nzoia", "Turkana",
  "Uasin Gishu", "Vihiga", "Wajir", "West Pokot"
];

function Settings() {
  const [userId, setUserId] = useState("");
  const [pointValue, setPointValue] = useState("");
  const [apiKey, setApiKey] = useState("************");
  const [smsBalance, setSmsBalance] = useState(200);
  const [userName, setUserName] =  useState()
  const [county, setCounty] = useState("");
  const [status, setStatus] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("Unsubscribed");
  const [loggedInPhone, setLoggedInPhone] = useState();
  const [subsAmount, setSubsAmount] = useState();
  const [issuedSMS, setissuedSMS] = useState();
  const [purchasedSMS, setPurchasedSMS] = useState();
  const [myissuedSMS, setMyissuedSMS] = useState();
  const [myTotalSMS, setMyTotalSMS] = useState();
  const [uploadProgress, setUploadProgress] = useState(0); // 0 to 100

  const [showSubModal, setShowSubModal] = useState(false);
  const [subPhone, setSubPhone] = useState("");
  const [subLoading, setSubLoading] = useState(false);

  const [showSmsModal, setShowSmsModal] = useState(false);
  const [smsQty, setSmsQty] = useState("");
  const [smsTotal, setSmsTotal] = useState(0);
  const [smsPhone, setSmsPhone] = useState("");
  const [smsLoading, setSmsLoading] = useState(false);

  const [error, setError] = useState(''); 
  const [isLoading, setIsLoading] = useState(false);
  const [IsLoadingSMS, setIsLoadingSMS] = useState(false);
  const [IsLoadingLocation, setIsLoadingLocation] = useState(false);
  const [isLoadingPoints, setIsLoadingPoints] = useState();
  const navigate = useNavigate();
  const [defaultSenderId, setdefaultSenderId] = useState();

  const [senderIDStatus, setsenderIDStatus] = useState("Approved");
  const [approvedsenderId, setapprovedsenderId] = useState("KUZA INFO");

  

  

  useEffect(() => {
    const auth = getAuth(app);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setUserId(user.uid);
        loadSettings(user.uid);
        fetchUserStatus(uid);
        fetchGlobalSettings();
        checkSenderIDApplication(uid);
      }
    });
  }, []);

  const loadSettings = async (uid) => {
    const docRef = doc(db, "settings", uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      setPointValue(data.pointValue || "");
      setCounty(data.county || "");   
    }
  };

  const savePointValue = async () => {
    setIsLoadingPoints(true);
    if (!userId) return;
    await setDoc(doc(db, "settings", userId), { pointValue }, { merge: true });
    setIsLoadingPoints(false)
    swal('Success', `Point value saved`, 'info');
  };

  const saveCounty = async () => {
    setIsLoadingLocation(true);
    if (!userId) return;
    await setDoc(doc(db, "settings", userId), { county }, { merge: true });
    setIsLoadingLocation(false)
    swal('Success', `Business location saved`, 'info');
  };

  const fetchUserStatus = async (uid) => {
    const userQuery = query(collection(db, "users"), where("userId", "==", uid));
    const querySnapshot = await getDocs(userQuery);
    querySnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      setStatus(data.status || "Unsubscribed");
      setUserName(data.businessName);
      setLoggedInPhone(data.phone);
      setPurchasedSMS(data.purchasedSMS);
      setMyissuedSMS(data.issuedSMS);
      setApiKey(data.apiKey || "************");

      const theissuedSMS = parseInt(data.issuedSMS);
      const myPurchasedSMS = data.purchasedSMS; 

      const totalSMS = theissuedSMS + myPurchasedSMS;
      setMyTotalSMS(totalSMS);

      // Subscription check
      const subscriptionEnd = data.subscriptionEnd?.toDate?.();
      if (subscriptionEnd) {
        const now = new Date();
        const isExpired = now > subscriptionEnd;
        setSubscriptionStatus(isExpired ? "Expired" : "Active");
      } else {
        setSubscriptionStatus("Unsubscribed");
      }

      
    });
  };

  const fetchGlobalSettings = async() => {
    const userQuery = query(collection(db, "globalSettings"), where("docID", "==", "wqSDO1OEBintZqf0svF6"));
    const querySnapshot = await getDocs(userQuery);
    querySnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      setSubsAmount(data.subsAmount);
      setissuedSMS(data.issuedSMS);
      setdefaultSenderId(data.defaultSenderId);
    });
  };

  //
  const [checking, setChecking] = useState(true);
  const [senderIDCreatedTime, setSenderIDCreatedTime] = useState(null);

 
  const checkSenderIDApplication = async (uid) => {
    try {
      const q = query(
        collection(db, "senderIDRequests"),
        where("userId", "==", uid) // Ensure the field name is correct in your Firestore documents
      );
      const snapshot = await getDocs(q);
      const docData = snapshot.docs[0].data();
      setSenderIDCreatedTime(docData.timeCreated);

      setsenderIDStatus(docData.status);
      setapprovedsenderId(docData.senderId);

      setHasAppliedSenderID(!snapshot.empty);
    } catch (error) {
      //console.log("")
      //console.error("Error checking sender ID application:", error);
    } finally {
      setChecking(false);
    }
  };

  const getApprovalDateMessage = (timeCreated) => {
    if (!timeCreated) return "";

    const createdDate = timeCreated.toDate(); // Firestore Timestamp to Date
    const approvalDate = new Date(createdDate);
    approvalDate.setDate(approvalDate.getDate() + 14); // Add 14 days

    // Format the date manually
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = approvalDate.toLocaleDateString(undefined, options); // e.g., "June 25, 2025"

    return `You’ve already applied for a branded SMS Sender ID. It will be ready by ${formattedDate}.`;
  };



  //format the phone number 
  const formatPhoneNumber = (number) => {
    // Strip non-numeric characters
    let cleaned = number.replace(/[^0-9]/g, '');

    // Handle various cases
    if (cleaned.startsWith('0')) {
      cleaned = '254' + cleaned.slice(1); // Replace leading 0 with 254
    } else if (cleaned.startsWith('254')) {
      // No change needed
    } else if (cleaned.startsWith('7')) {
      cleaned = '254' + cleaned; // Add 254 if starts with 7
    } else if (cleaned.startsWith('+254')) {
      cleaned = cleaned.slice(1); // Remove the + sign
    } else if (cleaned.startsWith('1')) {
      cleaned = '254' + cleaned; // For landlines or similar cases starting with 1
    }

    // Ensure the number has 12 digits
    if (cleaned.length === 12 && cleaned.startsWith('254')) {
      return cleaned;
    } else {
      setError('Please enter a valid phone number in the format 254XXXXXXXXX');
      return null;
    }
  };


  const [hasAppliedSenderID, setHasAppliedSenderID] = useState(false);






  //upload docs
  const storage = getStorage();
  const db = getFirestore();
  const auth = getAuth();

  const [show, setShow] = useState(false);
  const [safaricomFile, setSafaricomFile] = useState(null);
  const [airtelFile, setAirtelFile] = useState(null);
  const [telkomFile, setTelkomFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSubmit = async () => {

    if(status != "Subscribed"){
      swal('Subscribe to Continue', "You have to be subscribed in order to Buy Branded Sender ID", 'info');
      return;
    }

    if(subscriptionStatus === "Expired"){
      swal('Subscribe to Continue', "Renew your subscription in order to Buy Branded Sender ID", 'info');
      return;
    }

    navigate("/sender-id")
  };
  //end submit


  // subscribe 
  const handleSubscriptionPayment = async () => {

    setIsLoading(true);

    if (!subPhone || !subPhone.match(/^(\+254|254|0)?(1|7)\d{8}$/)) {
      swal('Error', "Enter a valid Safaricom number.", 'error');
      setIsLoading(false);
      return;
    }

    //setSubLoading(true); // Set loading after validation
  
    const formattedPhone = formatPhoneNumber(subPhone);
    const bio = userName;


    try {
      // // TODO: Trigger STK Push logic here
      // alert(`STK Push sent to ${subPhone}. You’ll be charged KES 1000.`);

      // // After success, close modal
      // setShowSubModal(false);
      // setSubPhone("");

        //const displayAmount = "5";
        const displayAmount = subsAmount;
      
        // Your Firebase Function URL
        const baseUrl = 'https://us-central1-kuzapoints.cloudfunctions.net/paymentApi';

        const paymentDesc = "Initial Setup";

        makePayment(displayAmount, formattedPhone, bio, paymentDesc)

        // Function to make a payment using fetch
        async function makePayment(amount, contactPhoneNumber, contactName, description) {
          try {
            const payload = {
              amount,
              contact_phone_number: contactPhoneNumber,
              contact_name: contactName,
              description,
            };

            const response = await fetch(`${baseUrl}/make-payment`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload),
            });

            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.error || 'Payment request failed');
            }

            const data = await response.json();
            // Access the transaction ID
            console.log(data)
            const transactionId = data?.data?.data?.transaction?.id;

            //console.log('🧾 Transaction ID:', transactionId);


            // Show SweetAlert with two buttons
                swal({
                  title: 'Payment Initiated',
                  text: 'Have you completed the payment on your phone?',
                  icon: 'info',
                  buttons: {
                    cancel: {
                      text: "No, I haven't paid",
                      visible: true,
                      closeModal: true,
                    },
                    confirm: {
                      text: 'Yes, I have paid',
                      closeModal: true,
                    },
                  },
                }).then((confirmed) => {
                  if (confirmed) {
                    //console.log('✅ User confirmed they paid');
                    // Optionally call verifyPayment(transactionId) here
                    verifyPayment(transactionId) 
                  } else {

                    console.log('⏳ User has not completed the payment yet');
                  }
                });
            return transactionId;
          } catch (error) {
            console.error('❌ Error making payment:', error.message);
          }
        }


        //verify payments

        // Function to verify payment
        async function verifyPayment(transactionId) {
          try {
            const response = await fetch(`${baseUrl}/verify-payment/${transactionId}`);
            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.error || 'Verification failed');
            }

            const data = await response.json();
            const transaction = data?.data?.data?.transaction?.[0];

            console.log('✅ Payment Verified:', transaction);

            if (transaction.status === "success") {
            // swal('Payment Verified!', 'Your payment has been successfully processed.', 'success');

                const payMethod = "Mpesa";
                const currency = "KES";
                const responseReference = transactionId;
                const responseTrans = "success"; 

                processPayment(payMethod, currency,responseReference, responseTrans , displayAmount );
                toast.success(`Payment was successful, please wait....`);

            } else {
              //swal('Payment Still Pending', `Status: ${transaction.status}`, 'info');
              //window.location.reload();
              swal({
                title: 'Payment Still Pending',
                text: transaction.status,
                icon: 'info',
                buttons: {
                  cancel: 'Cancel',
                  retry: {
                    text: 'Try Again',
                    value: 'retry',
                  },
                },
              }).then((value) => {
                if (value === 'retry') {
                  verifyPayment(transactionId); // Recursively call the function again
                }
              });
              
            }
          } catch (error) {
            console.error('❌ Verification Error:', error.message);
            swal('Verification Failed', error.message, 'error');
          }
        }




    } catch (err) {
      console.error(err);
      alert("Failed to initiate payment. Try again.");
    } finally {
      setSubLoading(false);
    }
  };


  const processPayment = async (payMethod, currency,responseReference, responseTrans , displayAmount) => {
    var timeStamp = new Date();
    toast.info(`setting up your account....`);
    
    try {

      const newDataRef = doc(collection(db, "Income"));
      setDoc(newDataRef, {

            loggedInUser: userId,
            paymentDate: timeStamp,
            paymentMethod: payMethod,
            userId: auth.currentUser.uid,
            currency,
            responseReference, 
            responseTrans, 
            displayAmount,
            paymentFor:"Subscription",
            docId:newDataRef.id

      }).then(()=>{

          toast.info(`setting up your account....`);
          const startDate = Timestamp.now();
          const endDate = Timestamp.fromDate(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)); // 30 days later

          const userDocRef = doc(db, "users", userId); // Replace userId with actual document ID
          updateDoc(userDocRef, {
            status: "Subscribed",
            subscriptionStart: startDate,
            subscriptionEnd: endDate,
            issuedSMS: issuedSMS,

          }).then(()=>{

            const phoneNumber = loggedInPhone
            toast.info(`setting up your account....`);
            const message = `Hello ${userName}, thank you for subscribing to our platform! Your 30-day subscription is now active. You can now start rewarding your customers and accessing premium features. Karibu!`
            sendSms(message, phoneNumber);

          })

        })

    } catch (error) {
        console.error("Error adding document: ", error);
        swal('Error!', 'An error occured!', 'error');
    }

  }



    const sendSms = async (message, phoneNumber) => {
            const auth = getAuth();
            const user = auth.currentUser;
        
            if (!user) {
                console.error("User not logged in");
                return;
            }
        
            try {
                const token = await user.getIdToken();
        
                const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ message, phoneNumber }),
                });
        
                const data = await response.json();
        
                if (response.ok) {
                   swal("Success!", "Package subscribed successfully", "success");
                  window.location.reload();
                  return true;
                } else {
                   swal("Success!", "Package subscribed successfully", "success");
                    window.location.reload();
                    return true;
                }
            } catch (err) {
                swal("Success!", "Package subscribed successfully", "success");
                window.location.reload();
                return true;
            }
      };

  //sms purchase 
  const handleSmsPurchase = async () => {

    if(status != "Subscribed"){
      swal('Subscribe to Continue', "You have to be subscribed in order to buy SMS Credits", 'info');
      return;
    }

    if(subscriptionStatus === "Expired"){
      swal('Subscribe to Continue', "Renew your subscription in order to buy SMS Credits.", 'info');
      return;
    }

    if (!smsQty || isNaN(smsQty) || smsQty <= 0) {
      swal('Error', "Enter a valid quantity of SMS.", 'error');
      return;
    }

    setIsLoadingSMS(true);
    if (!smsPhone || !smsPhone.match(/^(\+254|254|0)?(1|7)\d{8}$/)) {
      swal('Error', "Enter a valid Safaricom number.", 'error');
      setIsLoadingSMS(false);
      return;
    }

  
    const formattedPhone = formatPhoneNumber(smsPhone);
    const bio = userName;

    try {
      // TODO: Connect to STK Push API

      const displayAmount = smsTotal;
    
      // Your Firebase Function URL
      const baseUrl = 'https://us-central1-kuzapoints.cloudfunctions.net/paymentApi';

      const paymentDesc = "SMS";

      makePayment(displayAmount, formattedPhone, bio, paymentDesc)

      // Function to make a payment using fetch
      async function makePayment(amount, contactPhoneNumber, contactName, description) {
        try {
          const payload = {
            amount,
            contact_phone_number: contactPhoneNumber,
            contact_name: contactName,
            description,
          };

          const response = await fetch(`${baseUrl}/make-payment`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Payment request failed');
          }

          const data = await response.json();
          // Access the transaction ID
          console.log(data)
          const transactionId = data?.data?.data?.transaction?.id;

          //console.log('🧾 Transaction ID:', transactionId);


          // Show SweetAlert with two buttons
              swal({
                title: 'Payment Initiated',
                text: 'Have you completed the payment on your phone?',
                icon: 'info',
                buttons: {
                  cancel: {
                    text: "No, I haven't paid",
                    visible: true,
                    closeModal: true,
                  },
                  confirm: {
                    text: 'Yes, I have paid',
                    closeModal: true,
                  },
                },
              }).then((confirmed) => {
                if (confirmed) {
                  //console.log('✅ User confirmed they paid');
                  // Optionally call verifyPayment(transactionId) here
                  verifyPayment(transactionId) 
                } else {

                  console.log('⏳ User has not completed the payment yet');
                }
              });
          return transactionId;
        } catch (error) {
          console.error('❌ Error making payment:', error.message);
        }
      }


      //verify payments

      // Function to verify payment
      async function verifyPayment(transactionId) {
        try {
          const response = await fetch(`${baseUrl}/verify-payment/${transactionId}`);
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Verification failed');
          }

          const data = await response.json();
          const transaction = data?.data?.data?.transaction?.[0];

          console.log('✅ Payment Verified:', transaction);

          if (transaction.status === "success") {
           // swal('Payment Verified!', 'Your payment has been successfully processed.', 'success');

              const payMethod = "Mpesa";
              const currency = "KES";
              const responseReference = transactionId;
              const responseTrans = "success"; 

              processSMSPayment(payMethod, currency,responseReference, responseTrans , displayAmount, smsTotal );
              toast.success(`please wait....`);

          } else {
            //swal('Payment Still Pending', `Status: ${transaction.status}`, 'info');
            //window.location.reload();
             swal({
              title: 'Payment Still Pending',
              text: transaction.status,
              icon: 'info',
              buttons: {
                cancel: 'Cancel',
                retry: {
                  text: 'Try Again',
                  value: 'retry',
                },
              },
            }).then((value) => {
              if (value === 'retry') {
                verifyPayment(transactionId); // Recursively call the function again
              }
            });
            
          }
        } catch (error) {
          console.error('❌ Verification Error:', error.message);
          swal('Verification Failed', error.message, 'error');
        }
      }




    } catch (err) {
      console.error(err);
      alert("Failed to process payment. Try again.");
    } finally {
      setSmsLoading(false);
    }
  };


  const processSMSPayment = async (payMethod, currency,responseReference, responseTrans , displayAmount, smsTotal) => {
    var timeStamp = new Date();
    toast.info(`Please wait...`);
    
    try {

      const newDataRef = doc(collection(db, "Income"));
      setDoc(newDataRef, {

            loggedInUser: userId,
            paymentDate: timeStamp,
            paymentMethod: payMethod,
            userId: auth.currentUser.uid,
            currency,
            responseReference, 
            responseTrans, 
            displayAmount,
            paymentFor:"SMS",
            docId:newDataRef.id

      }).then(()=>{

          toast.info(`Please wait....`);
          const startDate = Timestamp.now();

          //purchasedSMS

          const newSetSms = smsTotal + purchasedSMS;

          const userDocRef = doc(db, "users", userId); // Replace userId with actual document ID
          updateDoc(userDocRef, {
            purchasedSMS: newSetSms,
            purchasedSMSDate: startDate,

          }).then(()=>{

            const phoneNumber = loggedInPhone;
            toast.info(`Please Wait....`);
            const message = `Hello ${userName}, you have successfully bought ${smsTotal} SMS.`
            sendSmsNew(message, phoneNumber);

          })

        })

    } catch (error) {
        console.error("Error adding document: ", error);
        swal('Error!', 'An error occured!', 'error');
    }

  }



      const sendSmsNew = async (message, phoneNumber) => {
            const auth = getAuth();
            const user = auth.currentUser;
        
            if (!user) {
                console.error("User not logged in");
                return;
            }
        
            try {
                const token = await user.getIdToken();
        
                const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ message, phoneNumber }),
                });
        
                const data = await response.json();
        
                if (response.ok) {
                             swal("Success!", "More SMS purchased successfully", "success");
          window.location.reload();
          return true
                } else {
                            swal("Success!", "More SMS purchased successfully", "success");
          window.location.reload();
          return true
                }
            } catch (err) {
                         swal("Success!", "More SMS purchased successfully", "success");
          window.location.reload();
          return true
            }
      };


  //console.log(hasAppliedSenderID)



  return (
    <div className="dashBCont">
      <LeftBar />
      <div className="dashBcontA">
        <NavBarAccount />

        <Container className="mt-4">
          <h3 className="mb-4">Business Settings</h3>

          {/* Subscription Card */}
          <Card className="mb-4">
            <Card.Body>
              <Card.Title className="myPrimaryColor">Subscription Status</Card.Title>
              <Card.Text className="text-muted small">
                This service runs on a monthly subscription of <strong>KSh {subsAmount}</strong>.  
                <br />
                When you subscribe, you get:
                <ul className="mb-2">
                  <li>{issuedSMS} free SMS every month. You can buy more sms at Ksh. 1 per SMS</li>
                  <li>Access to Kuza Points loyalty system</li>
                  <li>Points tracking and redemption management</li>
                  <li>SMS alerts for visits and redemptions</li>
                  <li>API key integration for advanced usage</li>
                </ul>
              </Card.Text>

                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    className={
                      status === "Subscribed" && subscriptionStatus !== "Expired"
                        ? "text-success"
                        : "text-danger"
                    }
                  >
                    {status === "Subscribed"
                      ? subscriptionStatus === "Expired"
                        ? "Expired"
                        : "Active"
                      : "Unsubscribed"}
                  </span>
                </p>

                {status !== "Subscribed" || subscriptionStatus === "Expired" ? (
                  <Button className="myPrimaryBtn" onClick={() => setShowSubModal(true)}>
                    Subscribe to Get Started
                  </Button>
                ) : null}



            </Card.Body>
          </Card>


          {/* Points Card */}
          <Card className="mb-4">
            <Card.Body>
              <Card.Title className="myPrimaryColor">How much are your Points Worth</Card.Title>
              <Card.Text className="text-muted small"> 
                Define how much one loyalty point is worth in Kenya Shillings.  
                <br />
                Every time a customer visits your business (e.g. Carwash, Kinyozi, Salon), they earn points. 
                These points can be redeemed for free services or discounts.  
                For example: If 1 point = KSh 10 and a customer has 5 points, that’s worth KSh 50.
              </Card.Text>
              <InputGroup className="mb-3">
                <InputGroup.Text>KSh</InputGroup.Text>
                <Form.Control
                  type="number"
                  placeholder="e.g. 10"
                  value={pointValue}
                  onChange={(e) => setPointValue(e.target.value)}
                />
              </InputGroup>

              {isLoadingPoints ? (
                <Button disabled className="mt-3 myPrimaryBtn">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                 Updating....
                </Button>
            ) : (
                <Button className="mt-3 myPrimaryBtn" onClick={savePointValue}>
                 Save Point Value
                </Button>
            )}
              {/* <Button variant="success" onClick={savePointValue}>Save Point Value</Button> */}
            </Card.Body>
          </Card>

          {/* SMS Balance Card */}
          <Card className="mb-4">
            <Card.Body>
              <Card.Title className="myPrimaryColor">SMS Balance</Card.Title>
              <Card.Text className="text-muted small">
              You currently have <strong>{myTotalSMS}</strong> SMS. Each SMS costs KSh 1.  
              <br />
              SMS are used to notify your customers after every visit, showing them how many points they’ve earned.  
              They’re also used when a customer wants to redeem points:  
              one SMS is sent with an OTP code for verification, and a second confirmation SMS is sent once the redemption is complete.  
              You can also use SMS for sending bulk promotional messages to your existing customers on the platform.
            </Card.Text>
 
              <Button className="myPrimaryBtn" onClick={() => setShowSmsModal(true)}>Buy More SMS Credit</Button>
            </Card.Body>
          </Card>

          {/* County Card */}
          <Card className="mb-4">
            <Card.Body>
              <Card.Title className="myPrimaryColor">Business Location</Card.Title>
              <Card.Text className="text-muted small">Select the county where you are located at</Card.Text>
              <Form.Select value={county} onChange={(e) => setCounty(e.target.value)}>
                <option>Select County</option>
                {counties.map((c, i) => (
                  <option key={i} value={c}>{c}</option>
                ))}
              </Form.Select>

            {IsLoadingLocation ? (
                <Button  disabled className="mt-3 myPrimaryBtn">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                 Updating....
                </Button>
            ) : (
                <Button className="mt-3 myPrimaryBtn" onClick={saveCounty}>
                 Update Location
                </Button>
            )}
              {/* <Button variant="primary" className="mt-3" >Save Location</Button> */}
            </Card.Body>
          </Card>

        {/* Branded SMS Sender ID Card */}
        {hasAppliedSenderID ? (
        <Card className="mb-4">
          <Card.Body>
            
             <Card.Title className="myPrimaryColor">Sender ID Request Status</Card.Title>

            {senderIDStatus === "Approved" ? (
              <Card.Text className="text-success fw-semibold">
                ✅ Congratulations! Your branded SMS Sender ID {approvedsenderId} has been approved. You can now send messages using it.
              </Card.Text>
            ) : senderIDStatus === "Correction" ? (
              <Card.Text className="text-danger fw-semibold">
                ⚠️ We’ve reviewed your Sender ID request and some changes are needed. We’ve sent you an email with the specific corrections. Please respond to that email with the corrected documents to proceed
              </Card.Text>
            ) : (
              <Card.Text className="text-muted small">
                {getApprovalDateMessage(senderIDCreatedTime)} We’ll notify you once it’s approved.
              </Card.Text>
            )}
          </Card.Body>
        </Card>
      ) : (
        <Card className="mb-4">
          <Card.Body>
            <Card.Title className="myPrimaryColor">Branded SMS Sender ID (Optional)</Card.Title>
            <Card.Text className="text-muted small">
              Buy a branded SMS sender ID with your business name. This lets your customers see your business name as the sender of SMS messages instead of our default <strong>{defaultSenderId}</strong>.
            </Card.Text>

            <Button className="myPrimaryBtn" onClick={handleSubmit}>
              Buy Branded Sender ID
            </Button>
          </Card.Body>
        </Card>
      )}


          {/* API Key Card */}
          <Card className="mb-4">
            <Card.Body>
              <Card.Title className="myPrimaryColor">API Key</Card.Title>
              <Card.Text className="text-muted small">This key can be used to integrate Kuza Points with other systems you build.</Card.Text>
              <InputGroup>
                <Form.Control type="text" value={apiKey} readOnly />
                <Button variant="secondary" onClick={() => swal('Copied', "Copied to your clipboard", 'success')}>
                  <FontAwesomeIcon icon={faEye} />
                </Button>
              </InputGroup>
            </Card.Body>
          </Card>


        </Container>
      </div>


      <Modal show={showSubModal} onHide={() => setShowSubModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="myPrimaryColor">Subscribe to Access</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You will be charged <strong>KES {subsAmount}</strong> for your subscription.</p>
          <Form.Group>
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="tel"
              placeholder="Enter Safaricom number"
              value={subPhone}
              onChange={(e) => setSubPhone(e.target.value)}
            />
            <Form.Text className="text-muted">
              A Prompt will be sent to this number to make payment.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="btn-sm" onClick={() => setShowSubModal(false)} disabled={subLoading}>
            Cancel
          </Button>
          {/* <Button variant="primary" onClick={handleSubscriptionPayment} disabled={subLoading}>
            {subLoading ? "Processing..." : "Subscribe"}
          </Button>  */}

           {isLoading ? (
                <Button className="myPrimaryBtn" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                 Making Payments....
                </Button>
            ) : (
                <Button className="myPrimaryBtn" onClick={handleSubscriptionPayment}>
                Make Payment
                </Button>
            )}

        </Modal.Footer>
      </Modal>

      <Modal show={showSmsModal} onHide={() => setShowSmsModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="myPrimaryColor">Buy More SMS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Number of SMS to Buy</Form.Label>
            <Form.Control
              type="number"
              min="1"
              placeholder="Enter quantity"
              value={smsQty}
              onChange={(e) => {
                const qty = e.target.value;
                setSmsQty(qty);
                setSmsTotal(qty * 1); // assuming 1 bob per SMS
              }}
            />
          </Form.Group>

          <p>
            <strong>Total Cost:</strong> KES {smsTotal || 0}
          </p>

          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="tel"
              placeholder="Enter Safaricom number"
              value={smsPhone}
              onChange={(e) => setSmsPhone(e.target.value)}
            />
            <Form.Text className="text-muted">
              A prompt will be sent to this number to make payment.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="btn-sm" onClick={() => setShowSmsModal(false)} disabled={smsLoading}>
            Cancel
          </Button>
          {/* <Button variant="primary" onClick={handleSmsPurchase} disabled={smsLoading || !smsQty}>
            {smsLoading ? "Processing..." : `Pay KES ${smsTotal}`}
          </Button> */}
            {IsLoadingSMS ? (
                <Button className="myPrimaryBtn" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                /> 
                 Making Payments....
                </Button>
            ) : (
                <Button className="myPrimaryBtn" onClick={handleSmsPurchase}>
                Make Payment
                </Button>
            )}
        </Modal.Footer>
      </Modal>

      <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          transition={Bounce}  
        />

    </div>
  );
}

export default Settings;